import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { GetTransactionsByRelatedDriverResponse } from "@qivia/schemas-cards-transactions";
import { RootState } from "../../../redux/store";
import { QueryStatus, axiosInstanceWithPhoneToken } from "../../../utils";

export interface TransactionsState {
  transactionsStatus: QueryStatus;
  transactions: GetTransactionsByRelatedDriverResponse;
}

const initialState: TransactionsState = {
  transactionsStatus: "idle",
  transactions: [],
};

export const getDriverTransactionsAsync = createAsyncThunk(
  "getDriverTransactions/call/",
  async (payload: { companyUuid: string }) => {
    const phoneToken = localStorage.getItem("phoneToken");
    if (!phoneToken) {
      throw Error();
    }
    const axios = axiosInstanceWithPhoneToken(phoneToken);
    const response = await axios.get<GetTransactionsByRelatedDriverResponse>(
      `/driver_access/driver/transactions`,
      { params: payload },
    );
    return response.data;
  },
);

export const transactionsSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDriverTransactionsAsync.pending, (state) => {
        state.transactionsStatus = "processing";
      })
      .addCase(getDriverTransactionsAsync.fulfilled, (state, action) => {
        state.transactions = action.payload;
        state.transactionsStatus = "success";
      })
      .addCase(getDriverTransactionsAsync.rejected, (state) => {
        state.transactionsStatus = "failed";
      });
  },
});

export const selectTransactions = (state: RootState) =>
  state.transactions.transactions;
export const selectTransactionsStatus = (state: RootState) =>
  state.transactions.transactionsStatus;

export default transactionsSlice.reducer;
